<template>
  <div :style="pageStyle">
    <img :src="companyUrl" alt="" :style="styleObjNew" v-if="companyUrl" style="border:1px solid #e5e5e5;box-sizing: border-box;">
    <div class="imgDiv" :style="[styleObjNew]" v-else>{{companyName}}</div>

  </div>
</template>

<script>

export default {
  props: {
    styleObj:Object, // 样式
    companyName:String,  // 公司简称
    companyUrl:String, // logo图片
    companyId:Number, // 公司id
  },
  data() {
    return {
      pageStyle:{}, //显示简称盒子样式
      styleObjNew:{},
    };
  },
  watch:{
    companyId(news,olds){
      this.$nextTick(()=>{
      this.getInit()
    })
    }
  },
  mounted(){
    this.$nextTick(()=>{
      this.getInit()
    })
  },
  methods: {
    // 初始化样式
    getInit(){
     this.styleObjNew = this.styleObj
     this.pageStyle = {
        width:this.styleObj.width,
        height:this.styleObj.height,
        borderRadius:this.styleObj.borderRadius||0,
        marginRight:this.styleObj.marginRight||0,
      }
     if(!this.companyUrl){
      if(parseInt(this.companyId)&&parseInt(this.companyId) % 2 == 0){
        this.styleObjNew.backgroundColor = "#f3bf57"
      }else{
        this.styleObjNew.backgroundColor = "#12B0DB"
      }
     }
    }
  }
};
</script>

<style scoped>
.imgDiv{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;
    color: #fff;
    padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/view/common/companyLogoCommon.vue